/* eslint-disable no-param-reassign */
const commonReducers = {
  setOpenFileVersionHistory: (state, action) => {
    state.openFileVersionHistory = action.payload;
    state.allFileVersions = [];
    state.pageNumber = 1;
    state.hasReachedFirstVersion = false;
    state.openDeleteVersionConfirmationModal = false;
  },
  setOpenDeleteVersionConfirmationModal: (state, action) => {
    state.openDeleteVersionConfirmationModal = action.payload;
  },
  addToFileVersions: (state, action) => {
    state.allFileVersions = [...state.allFileVersions, ...action.payload];
    const hasFirstVersion = state.allFileVersions.some(
      (version) => version.FileVersion === 'V1',
    );
    if (hasFirstVersion) {
      state.hasReachedFirstVersion = true;
    } else {
      state.hasReachedFirstVersion = false;
    }
  },
  getNextVersions: (state) => {
    state.pageNumber += 1;
  },
  deletedLastVersion: (state) => {
    state.hasReachedFirstVersion = false;
    state.allFileVersions = [];
    state.pageNumber = 1;
    state.openDeleteVersionConfirmationModal = false;
  },
};

const initialState = {
  openFileVersionHistory: false,
  pageNumber: 1,
  itemsPerPage: 7,
  hasReachedFirstVersion: false,
  allFileVersions: [],
  openDeleteVersionConfirmationModal: false,
};

export { initialState, commonReducers };
